import { ImageFilterProps, ImageStrokeEffectProps } from "../interfaces";
import { applyFilterToImage, applyStrokeEffectToImage } from "../utils/image";

export default class ImageLoader {
  private static tasks: Map<string, Promise<HTMLImageElement | null>> =
    new Map();

  static load(
    src: string | Blob,
    filter?: ImageFilterProps,
    strokeEffect?: ImageStrokeEffectProps,
  ) {
    const queryString = `filter=${JSON.stringify(filter)}&strokeEffect=${JSON.stringify(
      strokeEffect,
    )}`;
    const taskKey = `${src instanceof Blob ? URL.createObjectURL(src) : src}?${queryString}`;
    if (this.tasks.has(taskKey)) {
      return this.tasks.get(taskKey);
    }
    const task = this.createTask(src, filter, strokeEffect);
    this.tasks.set(taskKey, task);
    return task;
  }

  private static createTask(
    src: string | Blob,
    filter?: ImageFilterProps,
    strokeEffect?: ImageStrokeEffectProps,
  ): Promise<HTMLImageElement | null> {
    return new Promise(async (resolve) => {
      const img = new Image();
      img.crossOrigin = "anonymous";

      let srcToLoad = src;
      if (filter) {
        srcToLoad = await applyFilterToImage(srcToLoad, filter);
      }
      if (strokeEffect) {
        srcToLoad = await applyStrokeEffectToImage(srcToLoad, strokeEffect);
      }

      img.src =
        srcToLoad instanceof Blob ? URL.createObjectURL(srcToLoad) : srcToLoad;
      img.onload = () => {
        resolve(img);
      };
      img.onerror = () => {
        console.error(`Failed to load image: ${src}`);
        resolve(null);
      };
    });
  }
}
